import { render, staticRenderFns } from "./BiomasaMensualAnual.vue?vue&type=template&id=48fcfcfb&scoped=true"
import script from "./BiomasaMensualAnual.vue?vue&type=script&lang=js"
export * from "./BiomasaMensualAnual.vue?vue&type=script&lang=js"
import style0 from "./BiomasaMensualAnual.vue?vue&type=style&index=0&id=48fcfcfb&prod&scoped=true&lang=css"
import style1 from "./BiomasaMensualAnual.vue?vue&type=style&index=1&id=48fcfcfb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fcfcfb",
  null
  
)

export default component.exports